// search.js
import Axios from "axios"

;(({ log, warn }) => {
    const searchSection = document.querySelector('#search-section')
    const searchTrigger = document.querySelector('#search-trigger')
    const searchCloser = document.querySelector('#search-closer')

    if (!searchSection || !searchTrigger || !searchCloser) return

    const searchForm = searchSection.querySelector('.search-section__form')

    if (!searchForm) return

    const searchInput = searchForm.querySelector('.search-form__input')
    const searchResultsBlock = searchSection.querySelector('.search-section__results')
    const searchResultsScrollbox = searchSection.querySelector('.search-section__results-scrollbox')

    const activeSectionClass = 'search-section--active'
    const activeSearchResultsBlockClass = 'search-section__results--active'
    const url = searchSection.dataset.url

    let startRequesTimer = null
    const startRequestDelay = 200

    if (!searchInput
        || !searchResultsBlock
        || !searchResultsScrollbox) return

    searchResultsScrollbox.innerHTML = ''

    searchTrigger.addEventListener('click', e => {
        e.preventDefault()
        searchSection.classList.add(activeSectionClass)
        setTimeout(() => {
            searchInput.focus()
        }, 50)
    })

    searchCloser.addEventListener('click', e => {
        e.preventDefault()
        searchSection.classList.remove(activeSectionClass)
        searchResultsBlock.classList.remove(activeSearchResultsBlockClass)
        searchForm.reset()
    })

    searchInput.addEventListener('input', e => {
        clearTimeout(startRequesTimer)
        const { value } = e.target
        if (value.length >= 2) {
            startRequesTimer = setTimeout(async () => {
                await makeRequest(value)
            }, startRequestDelay)
        } else {
            searchResultsBlock.classList.remove(activeSearchResultsBlockClass)
        }
    })

    async function makeRequest(query) {
        try {
            const result = await Axios.get(url, {
                params: { q: query}
            })
            handleSearchResult(result.data.data)
        } catch (e) {
        }
    }

    function handleSearchResult(projects) {
        let serverString = ''

        if (projects.length == 0) {
            searchResultsBlock.classList.remove(activeSearchResultsBlockClass)
            return
        }
        
        projects.forEach(p => {
            const { server_name, server_url, sections : tagSections   } = p
            const tags = []

            tagSections.forEach(ts => {
                ts.tags.forEach(tag => {
                    if (!tag || tags.includes(tag)) return
                    tags.push(tag)
                })
            })

            const tagsString = buildTagsString(tags)
                serverString += buildServerString(server_name, server_url, tagsString)
        })

        searchResultsScrollbox.innerHTML = `
            <div class="search-results">
                <div class="search-results__list">
                    ${serverString}
                </div>
            </div>
        `
        
        searchResultsBlock.classList.add(activeSearchResultsBlockClass)
    }

    function buildTagsString(tags) {
        return tags.map(tag => `<span class="tag search-result__tag">${tag}</span>\n`).join('')
    }

    function buildServerString(serverName, serverUrl, tagsString) {
        return `
            <a href="${serverUrl}" class="search-results-entry">
                <span class="search-results-entry__title">${serverName}</span>
                ${tagsString}  
            </a>
        `
    }

})(CNS);